<template>
    <div class="overflow-y-auto">
        <DeleteProgramFrom v-if="isDeleteFormVisible" :element="elementToDelete" @close="isDeleteFormVisible = false" @acceptDeleteElement="deleteElement"/>
        
        <!-- <div class="flex justify-between px-[84px]"> -->
            <!-- <div class="search-bar flex items-center border-[#FFF] border-[1px] bg-[#FFF] bg-opacity-30 px-[10px] rounded-[6px]">
                <img src="@/assets/icons/magnify_icon.svg" class="w-3 h-3">
                <input v-model="searchQuery" class="text-[#FFF] text-[14px] bg-transparent rounded-md px-2 py-[3.5px] placeholder:text-[#FFF] outline-none w-[250px] " placeholder="Пошук..." type="text">
            </div> -->

            <!-- <InputComponent v-model="searchQuery" placeholder="Пошук..." class="w-[250px]"/> -->

            <!-- <div class="w-max flex justify-end">
                <div 
                    class="ml-[20px] flex items-center w-[110px] justify-between mr-[140px] text-[#FFF]">
                    <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer">
                    <div class="flex mx-[20px]">Сторінка: <input v-model="page" type="number" class="bg-transparent mx-2 w-[5ch] outline-none px-1"> / <span class="ml-[10px]">{{ maxPage }}</span></div>
                    <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer">
                </div> -->
                <!-- <div @click="$router.push('/create-training-program')" class="bg-[#BD9135] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Додати програму</span>
                </div> -->

                <!-- <div v-if="currentAdminRole != 'supervisor'" class="w-[228px]">
                    <ButtonComponent  @click="$router.push('/create-training-program')" :fullWidth="true">Додати програму</ButtonComponent>
                </div>
            </div>
        </div> -->
        <!-- <div class="border-b-[1px] border-white w-[90%] mx-auto flex justify-end mt-[16px] mb-[16px]">
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ trainingProgramsSum }}</span> програм
            </div>
            <div class="text-white ml-[20px]">
                <span class="text-[28px] font-semibold">{{ summariesWithMicrocycles }}</span> тренувань
            </div>
        </div> -->
        <keep-alive>
        <div class=" mx-auto  mb-5 rounded-[10px] overflow-y-auto">
            <!-- <table v-if="loaded" class="w-full">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                        <th class="px-3 py-2 w-[35%] text-start font-bold text-sm">Назва програми тренуваннь</th>
                        <th class="px-3 py-2 w-[20%] text-center font-bold text-sm">Сезони</th>
                        <th class="px-3 py-2 w-[20%] text-center font-bold text-sm">К-сть трен.</th>
                        <th class="w-[15%] py-2 cursor-pointer select-none text-end font-bold text-sm">
                            Додані групи
                        </th>
                        <th class="w-[5%]" ></th>
                        <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                            <div class="cursor-pointer w-[178px] z-[-40] pr-[26px]">Редагувати</div>
                        </th>
                        <th class="px-3 w-[10%] py-2 text-end font-bold text-sm">ID програми</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="program in allTrainingProgram" :key="program.hash" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                            <div class="rounded-full border-[1px] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle"
                                :style="{
                                    'background-color': program.groups.length ? program.groups[0].group_color : '#000',
                                }"
                            >
                                <span>{{ program.name.slice(0, 3) }}</span>
                            </div>
                        </td>
                        <td class="px-3 py-2 w-[35%] text-start font-medium text-sm">{{ program.name }}</td>
                        <td class="px-3 py-2 w-[20%] text-end font-medium text-sm ">
                            <div class="w-full h-full flex justify-center">
                                <div v-if="program.seasons.length">{{ program.seasons.map(e => e.name).join(', ') }}</div>
                                <div v-else class="w-[30px] h-[10px] bg-slate-500 animate-pulse rounded-full"></div>
                            </div>
                        </td>
                        <td class="px-3 py-2 w-[20%] text-end font-medium text-sm ">
                            <div class="w-full h-full flex justify-center">
                                <div v-if="program.trainings_count != null">{{ program.trainings_count }}</div>
                                <div v-else class="w-[30px] h-[10px] bg-slate-500 animate-pulse rounded-full"></div>
                            </div>
                        </td>
                        <td class="w-[15%] py-2 cursor-pointer select-none text-end font-medium text-sm">
                            {{
                                program.groups.length ? program.groups.map((group, index) => {
                                    return index == program.groups.length - 1 ? group.name : group.name + ', '
                                }).join('') : '--'
                            }}
                        </td>
                        <td class="w-[5%]" ></td>
                        <td class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                            <div class="cursor-pointer w-[178px] z-[-40] pr-[26px]">

                                <button 
                                    @click="$router.push('/training-program/' + program.id)"
                                    class="py-1 rounded-[10px] text-sm font-medium"
                                    :class="{
                                        'px-2' : screenWidth > 1450,
                                        'px-[4px]' : screenWidth < 1450
                                    }"        
                                >
                                    <img 
                                        src="@/assets/icons/pen_icon.svg" 
                                        class="w-6 h-6"
                                    >
                                </button>
                                <button 
                                    class="py-1 rounded-[10px] ml-[20px] text-sm font-medium text-red-600"
                                    :class="{
                                        'px-2' : screenWidth > 1450,
                                        'px-[4px]' : screenWidth < 1450
                                    }"   
                                    @click="isDeleteFormVisible = true; elementToDelete = program"   
                                    v-if="currentAdminRole != 'supervisor'"
                                >
                                    <img 
                                        src="@/assets/icons/trash_icon.svg" 
                                        class="w-6 h-6"   
                                    >
                                </button>

                            </div>
                        </td>
                        <td class="px-3 w-[10%] py-2 text-end font-medium text-sm">#{{program.id.split('-')[0]}}...</td>
                    </tr>
                </tbody>
            </table> -->

            <main class="main__wrapper">
                <div class="main__section">
                    <div class="search-header">
                        <div class="search-header__row">
                            <div class="search-bar">
                                <SearchInput :modelValue="searchQuery" @update:modelValue="e => searchQuery = e" />
                                <div 
                                    class="ml-[60px] flex items-center justify-between mr-[60px] text-[#FFF]">
                                    <!-- <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer"> -->
                                    <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="prevPage" >
                                        <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1.28613" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                            <path d="M11.7139 17L20.821 9.63878L20.821 24.3612L11.7139 17Z" fill="#474849"/>
                                        </svg>

                                    </div>
                                    <div class="flex mx-[10px]"><input v-model="page" type="number" class="bg-transparent border-[#474849] border-[1px] text-[12px] w-[34px] h-[34px] outline-none px-1 text-center rounded-[6px] mr-[10px]"> <span class="text-[10px] flex justify-center items-center">/</span> <span class="ml-[10px] border-[#474849] flex justify-center items-center bg-transparent border-[1px] w-[34px] h-[34px] text-[12px] outline-none px-1 text-center rounded-[6px] ">{{ maxPage }}</span></div>
                                    <!-- <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer"> -->
                                    <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="nextPage">
                                        <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.857422" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                            <path d="M23.4287 17L14.3216 9.63878L14.3216 24.3612L23.4287 17Z" fill="#474849"/>
                                        </svg>

                                    </div>
                                </div>
                            </div>
                            <ButtonComponent @click="$router.push('/create-training-program')" v-if="currentAdminRole != 'supervisor'">Додати</ButtonComponent>
                        </div>
                    </div>
                    <div class="border-b-[1px] border-[#8f8f8f] w-[100%] mx-auto flex justify-end mt-[16px] mb-[16px]">
                        <div class="text-[#8f8f8f]">
                            <span class="text-[28px] font-semibold">{{ trainingProgramsSum }}</span> програм
                        </div>
                        <div class="text-[#8f8f8f] ml-[20px]">
                            <span class="text-[28px] font-semibold">{{ summariesWithMicrocycles }}</span> тренувань
                        </div>
                    </div>
                    <div class="player-groups">
                        <div v-if="loaded && allTrainingProgram.length" class="programs-grid">
                            <div 
                                v-for="program in allTrainingProgram" 
                                :key="program.hash"
                                class="program-card"
                            >
                                <div class="program-card__top">
                                    <div 
                                        class="program-card__icon"
                                        :style="{
                                            backgroundColor: program.groups.length ? program.groups[0].group_color : '#2e2e2f'
                                        }"
                                    >
                                        <span>{{ program.name.slice(0, 3) }}</span>
                                    </div>
                                    <div class="program-card__title" :title="program.name">
                                        {{ program.name }}
                                    </div>
                                </div>

                                <div class="program-card__meta">
                                    <span class="label">Сезони</span>
                                    <span class="value">
                                        <template v-if="program.seasons.length">
                                            {{ program.seasons.map(e => e.name).join(', ') }}
                                        </template>
                                        <template v-else>
                                            --
                                        </template>
                                    </span>
                                </div>

                                <div class="program-card__meta">
                                    <span class="label">Тренування</span>
                                    <span class="value">
                                        <template v-if="program.trainings_count != null">
                                            {{ program.trainings_count }}
                                        </template>
                                        <span v-else class="skeleton-bar"></span>
                                    </span>
                                </div>

                                <div class="program-card__meta">
                                    <span class="label">Групи</span>
                                    <span class="value">
                                        <div v-if="program.groups.length" class="group-chips">
                                            <span 
                                                v-for="group in program.groups" 
                                                :key="group.group_id"
                                                class="group-chip"
                                                :style="{
                                                    borderColor: group.group_color || '#2e2e2f',
                                                    backgroundColor: (group.group_color || '#2e2e2f') + '26'
                                                }"
                                            >
                                                {{ group.name }}
                                            </span>
                                        </div>
                                        <span v-else>--</span>
                                    </span>
                                </div>

                                <div class="program-card__footer">
                                    <div class="program-card__id">
                                        #{{ program.id.split('-')[0] }}...
                                    </div>
                                    <div class="program-card__actions">
                                        <button 
                                            @click="$router.push('/training-program/' + program.id)"
                                            class="action-btn"
                                        >
                                            <img 
                                                src="@/assets/icons/pen_icon.svg" 
                                                class="w-5 h-5"
                                            >
                                        </button>
                                        <button 
                                            v-if="currentAdminRole != 'supervisor'"
                                            class="action-btn danger"
                                            @click="isDeleteFormVisible = true; elementToDelete = program"
                                        >
                                            <img 
                                                src="@/assets/icons/trash_icon.svg" 
                                                class="w-5 h-5"
                                            >
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="loaded" class="empty-state">
                            Нічого не знайдено
                        </div>
                    </div>
                </div>
            </main>

            <div v-if="!loaded" class="w-full h-[200px] relative">
                <div class="w-full mt-[14px] flex items-center justify-center absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
                    <!-- tailwind spinner -->
                    <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#DA4167] border-t-transparent absolute top-[50%] left-[50%]"></div>
                </div>
            </div>
        </div>
        </keep-alive>
    </div>
</template>

<script>
    import { getAllTrainingPrograms, getAllGroups, deleteTrainingProgramById, countTrainingPrograms, countSummariesWithMicrocycleId, countSummariesInCurrentProgram } from '@/services/apiRequests'
    import { ref, onMounted, watch } from 'vue'
    import { uuid } from 'vue3-uuid'
    import DeleteProgramFrom from './components/DeleteProgramForm.vue'
    import ButtonComponent from '@/components/uikit/Button/ButtonComponent.vue';

    function extractNumbers(str) {
        return str.match(/\d+/g)?.map(Number) || [];
    }

    export default {
        name: 'TrainingPrograms',

        setup() {
            const allTrainingProgram = ref([])

            const isDeleteFormVisible = ref(false)
            const elementToDelete = ref({})

            const trainingProgramsSum = ref(0)
            const summariesWithMicrocycles = ref(0)

            const page = ref(1)
            const maxPage = ref(1)

            const searchQuery = ref('')

            const allGroups = ref([])

            const loaded = ref(false)

            const nextPage = () => {
                if (page.value < maxPage.value) {
                    page.value++;
                }
            }

            const prevPage = () => {
                if (page.value > 1) {
                    page.value--;
                }
            }

            watch(page, async () => {
                await updateTrainingPrograms()
            });

            watch(searchQuery, async () => {
                page.value = 1
                await updateTrainingPrograms()
            });

            const deleteElement = async (element) => {
                await deleteTrainingProgramById(element.id)
                await updateTrainingPrograms()
                isDeleteFormVisible.value = false
            }

            const updateTrainingPrograms = async () => {
                allTrainingProgram.value = (await getAllTrainingPrograms(20 * page.value, 20 * (page.value - 1), searchQuery.value)).map(el => {
                    el.hash = uuid.v4()
                    el.trainings_count = null
                    return el
                }).sort((a, b) => {
                    const aNumbers = extractNumbers(a.name)
                    const bNumbers = extractNumbers(b.name)
                    if (aNumbers.length > 0 && bNumbers.length > 0) {
                        return bNumbers[0] - aNumbers[0]
                    } else if (aNumbers.length > 0) {
                        return 1
                    } else if (bNumbers.length > 0) {
                        return -1
                    } else {
                        return a.name.localeCompare(b.name)
                    }
                })
            }

            const countSummariesWithCurrentProgram = async (programId) => {
                return await countSummariesInCurrentProgram(programId)
            }

            onMounted(async () => {
                await updateTrainingPrograms()

                for (let i = 0; i < allTrainingProgram.value.length; i++) {
                    allTrainingProgram.value[i].trainings_count = await countSummariesInCurrentProgram(allTrainingProgram.value[i].id)
                    allTrainingProgram.value[i].hash = uuid.v4()
                }

                trainingProgramsSum.value = await countTrainingPrograms()

                maxPage.value = Math.ceil(trainingProgramsSum.value / 20)
                summariesWithMicrocycles.value = await countSummariesWithMicrocycleId()

                allGroups.value = (await getAllGroups()).data
                console.log('allGroups.value', allGroups.value)
                console.log('allTrainingProgram.value', allTrainingProgram.value)

                allTrainingProgram.value.forEach((program) => {
                    program.groups = allGroups.value.filter(group => program.groups.includes(group.group_id))
                })

                loaded.value = true
            })

            const currentAdminRole = ref(localStorage.getItem('userType'))

            return {
                allTrainingProgram,
                isDeleteFormVisible,
                elementToDelete,
                deleteElement,
                trainingProgramsSum,
                summariesWithMicrocycles,
                countSummariesWithCurrentProgram,
                page,
                maxPage,
                searchQuery,
                nextPage,
                prevPage,
                loaded,
                currentAdminRole
            }
        },

        components: {
            DeleteProgramFrom
        }
    }
</script>

<style lang="scss" scoped>
    .search-header__sub-row {
        flex-direction: row;

        @media screen and (max-width: 1056px) {
            flex-direction: column;
            gap: 12px;
        }
    }

    .search-bar {
        display: flex;
        gap: 10px;
    }

    @media screen and (max-width: 1450px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

    .programs-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        gap: 16px;
        width: 100%;
    }

    .program-card {
        background: #0f0f10;
        border: 1px solid #2a2a2b;
        border-radius: 12px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
    }

    .program-card:hover {
        border-color: #BD9135;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
        transform: translateY(-2px);
    }

    .program-card__top {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .program-card__icon {
        min-width: 52px;
        min-height: 52px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .program-card__title {
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .program-card__meta {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        font-size: 13px;
        color: #b3b3b3;
        align-items: center;
    }

    .program-card__meta .label {
        color: #8f8f8f;
    }

    .program-card__meta .value {
        color: #fff;
        font-weight: 500;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 6px;
    }

    .group-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        justify-content: flex-end;
    }

    .group-chip {
        border: 1px solid #2e2e2f;
        border-radius: 999px;
        padding: 2px 8px;
        color: #fff;
        font-size: 12px;
        background: rgba(255, 255, 255, 0.04);
        white-space: nowrap;
    }

    .program-card__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: auto;
        gap: 10px;
    }

    .program-card__id {
        color: #7d7d7d;
        font-size: 12px;
    }

    .program-card__actions {
        display: flex;
        gap: 10px;
    }

    .action-btn {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        border: 1px solid #2e2e2f;
        background: #1a1a1b;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color .2s ease, background-color .2s ease;
    }

    .action-btn:hover {
        border-color: #BD9135;
        background: #252526;
    }

    .action-btn.danger:hover {
        border-color: #DA4167;
        background: #2a1a1f;
    }

    .skeleton-bar {
        display: inline-block;
        width: 60px;
        height: 10px;
        border-radius: 6px;
        background: #2f2f30;
        animation: pulse 1.2s ease-in-out infinite;
    }

    @keyframes pulse {
        0% { opacity: 0.6; }
        50% { opacity: 1; }
        100% { opacity: 0.6; }
    }

    .empty-state {
        color: #8f8f8f;
        text-align: center;
        padding: 40px 0;
    }

    @media screen and (max-width: 768px) {
        .programs-grid {
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        }

        .program-card {
            padding: 12px;
        }
    }
</style>